// 3rd party
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';

// models
import { ContactCustomer } from 'app/shared/models/contact-customer.model';

@Component({
  selector: 'app-data-dialog',
  templateUrl: './data-dialog.component.html',
  styleUrls: ['./data-dialog.component.css']
})
export class DataDialogComponent {

  public buttons;
  public checkedItems: number = 0;
  public columns;
  public component;
  public data;
  public isLoading = false;
  public options;
  public selectedItem;

  constructor(
    public dialogRef: MatDialogRef<DataDialogComponent>,
    public translate: TranslateService,
  ) { }

  dynamicMethod(obj, button) {
    this.isLoading = true;

    let lst = this.data.filter(item => item.checked);
    let params = lst.map(obj => button.param === 'this' ? obj : obj[button.param]);
    this.component[button.method](params).subscribe(() => this.isLoading = false, data => this.isLoading = false, err => this.isLoading = false);
  }

  disableButton(button): boolean {
    const contact = JSON.parse(localStorage.getItem('currentContact')) as ContactCustomer;
    let disabled: boolean[] = new Array<boolean>();

    switch (button.condition) {
      case 'none': { disabled.push(this.checkedItems < 1); break; }
      case 'many': { disabled.push(this.checkedItems > 1); break; }
      case 'one': { disabled.push(this.checkedItems === 1); break; }
    }

    let requiredPermissions = button.permission;

    requiredPermissions.forEach(permission => {
      disabled.push(!ContactCustomer.hasPermission(permission, contact.RoleWebView.ActionsPermissions));
    });

    return disabled.includes(true);
  }

  onSelectionChange(a) {
    this.selectedItem = a;
    this.checkedItems = this.data.filter(item => item.checked).length;
  }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/data-dialog/data-dialog.component.ts